import { Box, IconButton, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { RiDeleteBinLine, RiFileEditLine } from 'react-icons/ri'
import { MdWarningAmber } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux';
import CTable from '../../../components/Table/table'
import { deleteAssistantRequest, suspendAssistantRequest } from '../../../modules/admin-modules/assistants/Actions';
import { openCreateAssistant } from '../../../modules/admin-modules/models/Actions';

const AssistantsTable = ({ setAdd, setSelectedData }) => {
    const assistants = useSelector((state) => state.assistants.assistants)
    const dispatch = useDispatch()
    const isLoading = useSelector((state) => state.assistants.isLoading)
    const [offset, setPage] = useState(0);
    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [selected, setSelected] = useState({
        id: ''
    })
    
    const viewData = (data) => {
        setSelectedData(data);
        setSelected(data);
        setAdd(false);
        dispatch(openCreateAssistant());
    };
    
    const Data =
        assistants?.map((data) => {
            return {
                ...data,
                id: data?.id,
                name: data?.name,
                phone: data?.phone,
                edit: (
                    <IconButton
                        variant='outline'
                        border='0'
                        color='gray.600'
                        aria-label='Edit Assistant'
                        fontSize='20px'
                        icon={<RiFileEditLine />}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedData(data);
                            setAdd(false);
                            dispatch(openCreateAssistant());
                        }}
                    />
                ),
                suspend: (
                    <IconButton
                        variant="outline"
                        border="0"
                        color="gray.600"
                        aria-label="Suspend Assistant"
                        fontSize="20px"
                        icon={
                            <MdWarningAmber
                                color={data?.deleted_at == null ? "red" : "green"}
                            />
                        }
                        onClick={(e) => {
                            e.stopPropagation();
                            dispatch(suspendAssistantRequest(data?.id, ''));
                        }}
                        isLoading={selected.id == data?.id ? false : false}
                    />
                ),
                delete: (<IconButton
                    variant='outline'
                    border='0'
                    color='gray.600'
                    aria-label='Delete Assistant'
                    fontSize='20px'
                    icon={<RiDeleteBinLine color='red' />}
                    onClick={(e) => {
                        e.stopPropagation();
                        dispatch(deleteAssistantRequest(data?.id));
                    }}
                />)
            };
        })
    const columns = [
        {
            Header: 'الاسم',
            accessor: 'name'
        },
        {
            Header: 'رقم الهاتف',
            accessor: 'phone'
        },
        {
            Header: 'إيقاف',
            accessor: 'suspend'
        },
        {
            Header: 'تعديل',
            accessor: 'edit'
        },
        {
            Header: 'حذف',
            accessor: 'delete'
        }
    ];


    return (
        <CTable
            selectedData={viewData}
            Columns={columns}
            Data={Data}
            path={'openModel'}
            Actions
            Title={``}
            subTitle=''
            btnTitle=""
            placeHolder=""
            noSearchBar={true}
            noFilter={true}
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar={true}
            isLoading={isLoading}
            perPage={size}
            totalPage={Math.ceil(assistants?.length / 10)}

        />
    )
}

export default AssistantsTable

